import { version } from '../../package.json';

export const environment = {
    production: true,
    appVersion: version,
    configUrl: 'https://avion-config-api.azurewebsites.net/api/GetApplicationConfiguration',
};

